export class ConfigurationSettingsDto
{
    private enable: string;
    private attribute: string;
    private description: string;

    getEnable(): string{
        return this.enable;
    }

    getAttribute(): string{
        return this.attribute;
    }

    getDescription(): string{
        return this.description;
    }

    fromJSON(data: any): ConfigurationSettingsDto
    {
        this.enable = data.enable;
        this.attribute = data.attribute;
        this.description = data.description;

        return this;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/configurationsettings/configurationsettingsdto.ts